export const POST_DETAILS_BEGIN = "POST_COMMENTS_BEGIN";
export const POST_DETAILS_SUCCESS = "POST_COMMENTS_SUCCESS";
export const POST_DETAILS_FAIL = "POST_COMMENTS_FAIL";

export const GET_DETAILS_BEGIN = "GET_COMMENTS_BEGIN";
export const GET_DETAILS_SUCCESS = "GET_COMMENTS_SUCCESS";
export const GET_DETAILS_FAIL = "GET_COMMENTS_FAIL";